export class TipoModel{
    Id: number = 0;
    EmpresaId: number = 0;
    Nombre: string = '';
    Observaciones : string = '';
}